import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface AssignState {
  assign: Record<any, any>;
}

const initialState: AssignState = {
  assign: {},
};

export const assignSlice = createSlice({
  name: "assign",
  initialState,
  reducers: {
    setAssign: (state, action: PayloadAction<Record<string, any>>) => {
      state.assign = action.payload;
    },
  },
});

export const { setAssign } = assignSlice.actions;
export default assignSlice.reducer;
